module.exports = __webpack_public_path__ + "img/u985.04653ef9.svg";